import { useState } from "react";
import axios from "axios";

export default function CreateBulkUsers({listId}) {

  const API_BASE = "https://api.ilogically.com/api";
  const APP_TOKEN = "87adfacc2dffc65ae172d59a9f0badda";

  const [jsonInput, setJsonInput] = useState("");
  const [result, setResult] = useState(null);

  const handleSubmit = async () => {

    try {

      const users = JSON.parse(jsonInput);

      const res = await axios.post(
        `${API_BASE}/users/create-bulk`,
        { users },
        { params: { appToken: APP_TOKEN ,listId:listId} }
      );

      setResult(res.data);

    } catch (err) {
      alert("Invalid JSON or API error");
    }
  };

  return (
    <div>

      <textarea
        rows={10}
        cols={80}
        placeholder='Paste JSON array here'
        value={jsonInput}
        onChange={(e) => setJsonInput(e.target.value)}
      />

      <br />

      <button onClick={handleSubmit}>
        Create Users
      </button>

      {result && (
        <div>
          <h4>Success</h4>
          <pre>{JSON.stringify(result.success, null, 2)}</pre>

          <h4>Failed</h4>
          <pre>{JSON.stringify(result.failed, null, 2)}</pre>
        </div>
      )}

    </div>
  );
}